// Native text extraction only. Policy.Anchor owns matching and confidence.
const snapshots=new WeakMap();
export function chapterText(chapter){
  const text=chapter.textContent||'';
  const cached=snapshots.get(chapter);if(cached?.text===text)return cached;
  const blocks=[{id:chapter.id,start:0,end:text.length}],elements=new Map([[chapter.id,chapter]]);
  const walker=document.createTreeWalker(chapter,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT);
  let node,offset=0;
  while((node=walker.nextNode())){
    if(node.nodeType===Node.TEXT_NODE)offset+=node.length;
    else if(node.id){blocks.push({id:node.id,start:offset,end:offset+(node.textContent||'').length});elements.set(node.id,node);}
  }
  const snapshot={text,blocks,elements};snapshots.set(chapter,snapshot);return snapshot;
}
export function textContext(block,start,end){
  const chapter=block?.closest('.book-chapter');if(!chapter)return null;
  const facts=chapterText(chapter),boundary=facts.blocks.find(item=>item.id===block.id);
  if(!boundary)return null;
  const from=boundary.start+start,to=boundary.start+end;
  return {quote:facts.text.slice(from,to),prefix:facts.text.slice(Math.max(0,from-64),from),suffix:facts.text.slice(to,to+64),fraction:from/Math.max(1,facts.text.length)};
}
